//======= QUERY PARAMETER KEYS =======//
export const RECEIVE_SMS_QUERY_PARAM = 'receiveSMS'
export const IS_RESERVATION_INVITE_QUERY_PARAM = 'isReservationInvite'

export const SALES_BOT_TRIP_SUMMARY_OVERLAY_GAP_PIXELS = 32
